/**
 * Internal SidebarPageLayout contexts.
 *
 * Split into "state" and "actions" contexts so action-only consumers
 * don't re-render on state changes. Lives in its own module so
 * SidebarTrigger can be extracted without re-importing
 * SidebarPageLayout (which would create a cycle through
 * CollapsiblePageHeader).
 */
import {createContext} from 'react'

export type SidebarPageLayoutState = {
  isDialogOpen: boolean
  isCollapsed: boolean
  triggerElement: HTMLButtonElement | null
  sidebarLabel: string | undefined
  hasSidebar: boolean
}

export type SidebarPageLayoutActions = {
  openDialog: () => void
  closeDialog: () => void
  setTriggerElement: (el: HTMLButtonElement | null) => void
  collapse: () => void
  expand: () => void
  toggleCollapse: () => void
  setSidebarLabel: (label: string | undefined) => void
  setHasSidebar: (hasSidebar: boolean) => void
}

const DEFAULT_STATE: SidebarPageLayoutState = {
  isDialogOpen: false,
  isCollapsed: false,
  triggerElement: null,
  sidebarLabel: undefined,
  hasSidebar: false,
}

export const SidebarPageLayoutStateContext = createContext<SidebarPageLayoutState>(DEFAULT_STATE)
export const SidebarPageLayoutActionsContext = createContext<SidebarPageLayoutActions | null>(null)
